export const NETWORKS: {
  [chainId: string]: {
    chainId: number;
    name: string;
    symbol: string;
    explorer: string;
    rpc: string;
  };
} = {
  '1': {
    chainId: 1,
    name: 'Mainnet',
    symbol: 'ETH',
    explorer: 'https://etherscan.io/',
    rpc: 'https://mainnet.infura.io/v3/60a7b2c16321439a917c9e74a994f7df',
  },
  '4': {
    chainId: 4,
    name: 'Rinkeby',
    symbol: 'ETH',
    explorer: 'https://rinkeby.etherscan.io/',
    rpc: 'https://rinkeby.infura.io/v3/60a7b2c16321439a917c9e74a994f7df',
  },
  '31337': {
    chainId: 31337,
    name: 'HardHat',
    symbol: 'GO',
    explorer: 'https://etherscan.io/',
    rpc: 'http://localhost:8545',
  },
};

// export const SUPPORTED_NETWORKS = process.env.SUPPORTED_NETWORKS || '1';
export const SUPPORTED_NETWORKS = process.env.SUPPORTED_NETWORKS || '1,4,31337';

export const AUTO_UPDATE_BALANCE_INTERVAL = 1000 * 5; // 15 seconds
export const DEFAULT_NETWORK = process.env.DEFAULT_NETWORK || '1';
